import _ from 'lodash';
import { LibraryListItem, VideoListItem } from './libraryListItem';
import { Typography } from '@design-system/components/typography/typography';
import { Skeleton } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolder } from '@fortawesome/pro-regular-svg-icons';
import clsx from 'clsx';

export type FolderListItem = {
  id: number;
  name: string;
  count: string;
  parentId: number | null;
  updatedAt: string;
  onClick: () => void;
};

export type LibraryListProps = {
  selectVideo: (id: string) => void;
  folders: FolderListItem[];
  videos: VideoListItem[];
  selectedIds: string[] | null;
  loading: boolean;
  searchText: string;
  fetchError: boolean;
  smallerView: boolean;
};
export const LibraryList = ({
  videos,
  folders,
  selectedIds,
  loading,
  selectVideo,
  searchText,
  fetchError,
  smallerView,
}: LibraryListProps) => {
  if (fetchError) {
    return (
      <div
        className={clsx(
          'flex flex-col justify-center items-center',
          smallerView && 'h-[180px]',
          !smallerView && 'h-[400px]',
        )}
      >
        Something went wrong. Please reload the page.
      </div>
    );
  }
  if (loading) {
    return (
      <div
        className={clsx(
          'w-full flex flex-col items-center gap-2',
          smallerView && 'h-[180px]',
          !smallerView && 'h-[400px]',
        )}
      >
        {Array.from({ length: 5 }, (_, i) => (
          <Skeleton variant="rounded" height={50} key={i} className="w-full" />
        ))}
      </div>
    );
  }
  if (_.isEmpty(videos)) {
    if (searchText) {
      return (
        <div
          className={clsx(
            'flex flex-col justify-center items-center',
            smallerView && 'h-[180px]',
            !smallerView && 'h-[360px]',
          )}
        >
          <Typography variant="bodyLarge">No result</Typography>
        </div>
      );
    }
    return (
      <div
        className={clsx(
          'flex flex-col justify-center items-center',
          smallerView && 'h-[180px]',
          !smallerView && 'h-[200px]',
        )}
      >
        <Typography variant="bodyLarge">
          Looks like you have no videos in your Library!
        </Typography>
        <Typography variant="bodyLarge">Upload your files first.</Typography>
      </div>
    );
  }

  return (
    <div
      className={clsx(
        'overflow-auto flex flex-col gap-2',
        smallerView && 'h-[180px]',
        !smallerView && 'h-[360px]',
      )}
    >
      <Typography>Folders</Typography>
      {folders.map((folder) => (
        <div
          key={folder.id}
          className="flex gap-4 cursor-pointer"
          onClick={folder.onClick}
        >
          <FontAwesomeIcon icon={faFolder} />
          <div className="flex flex-col gap-1">
            <Typography variant="body" size="medium">
              {folder.name}
            </Typography>
            <Typography variant="body" size="small" color="N-80">
              {folder.count}
            </Typography>
          </div>
        </div>
      ))}
      <Typography>Files</Typography>
      {videos.map((i) => (
        <LibraryListItem
          key={i.id}
          {...i}
          selected={!!selectedIds && selectedIds.includes(i.id)}
          selectedIndx={
            selectedIds && selectedIds.length === 1
              ? undefined
              : selectedIds?.indexOf(i.id)
          }
          selectVideo={selectVideo}
        />
      ))}
    </div>
  );
};
